import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
  Filler
} from "chart.js";
import { Box, Typography } from "@mui/material";
//import theme from "../../../configs/theme";

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend, Filler);

export default function WeeklyOperationsGraph({ data }) {
  const labels = ["Semana 1", "Semana 2", "Semana 3", "Semana 4"];
  const ingresos = data.map((item) => item.Ingresos);
  const pagos = data.map((item) => item.Pagos);
  const compras = data.map((item) => item.Compras);

  const chartData = {
    labels,
    datasets: [
      {
        label: "Pagos",
        data: pagos,
        fill: true,
        backgroundColor: "#9feef000",
        borderColor: "#6ce5e8",
        tension: 0,
      },
      {
        label: "Compras",
        data: compras,
        fill: true,
        backgroundColor: "#76b3d200",
        borderColor: "#41b8d5",
        tension: 0,
      },
      {
        label: "Ingresos",
        data: ingresos,
        fill: true,
        backgroundColor: "#8ad6c100",
        borderColor: "#4bc0a0",
        tension: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
    },
    scales: {
      x: {
        title: {
          display: false,
        },
      },
      y: {
        title: {
          display: true,
          text: "Montos",
        },
        beginAtZero: true,
      },
    },
  };

  return (
    <Box sx={{ height: "85%", width: "50%", mt: 0 }}>
      <Typography variant="body1" mb={0} textAlign={"center"}>
        Operaciones Semanales
      </Typography>
      <Line data={chartData} options={options} />
    </Box>
  );
}
